var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26309"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35718"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18294",
    d: "M8.111 4.556H6.556A1.556 1.556 0 0 0 5 6.111v9.333A1.556 1.556 0 0 0 6.556 17h7.778a1.556 1.556 0 0 0 1.556-1.556V6.111a1.556 1.556 0 0 0-1.556-1.556h-1.556m-4.667 0a1.556 1.556 0 0 0 1.556 1.556h1.556a1.556 1.556 0 0 0 1.556-1.556m-4.667 0A1.556 1.556 0 0 1 9.667 3h1.556a1.556 1.556 0 0 1 1.556 1.556",
    transform: "translate(-1.5 -1.5)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#f74945",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 965",
    transform: "translate(7 8)",
    style: {
      fill: "none",
      stroke: "#f74945",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    },
    d: "m0 0 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 966",
    transform: "translate(7 8)",
    style: {
      fill: "none",
      stroke: "#f74945",
      strokeLinecap: "round",
      strokeWidth: "1.5px"
    },
    d: "M4 0 0 4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCancel);
export default __webpack_public_path__ + "static/media/clipboard-cancel.d8a4f7edbb0d92ee5f446f4ab44c55b4.svg";
export { ForwardRef as ReactComponent };